module.exports = __webpack_public_path__ + "static/media/icon.f8453a71.png";